import { ICellRendererAngularComp } from 'ag-grid-angular';
import { GridApi, ICellRendererParams, IRowNode } from 'ag-grid-community';
import { Component } from '@angular/core';
import { NodeUtils } from '@core/utils/node.utils';
import { UuidUtils } from '@portal-shared/app/utils/uuid.utils';
import { ResourceLikeDto } from '@services/dtos/rows/resource-like.dto';
import { CellDropZoneComponent } from '@shared/components/cell-drop-zone/cell-drop-zone.component';
import { ProjectAssignmentRow } from '@shared/components/grids/rows/assignments/project-assignment-row';
import { UserCardComponent } from '@shared/components/user-card/user-card.component';
import { ResourceGroupRow } from '../../rows/groups/resource-group.row';

@Component({
    selector: 'al-resource-cell-renderer',
    templateUrl: './resource-cell-renderer.component.html',
    styleUrls: ['./resource-cell-renderer.component.scss'],
    imports: [CellDropZoneComponent, UserCardComponent]
})
export class ResourceCellRendererComponent implements ICellRendererAngularComp {
  public resource?: ResourceLikeDto;
  public node?: IRowNode<ProjectAssignmentRow | ResourceGroupRow>;
  public gridApi?: GridApi;
  public row?: ProjectAssignmentRow | ResourceGroupRow;
  public isUnassignedUser = false;

  public get isDroppable() {
    return NodeUtils.isCellDroppable(this.node);
  }

  public agInit(params: ICellRendererParams<ProjectAssignmentRow | ResourceGroupRow>): void {
    this.node = params.node;
    this.gridApi = params.api;
    this.row = params.data;
    const resource = this.row instanceof ProjectAssignmentRow ? this.row?.dto.resource : this.row?.toResourceLikeDto();

    if (this.row) {
      this.isUnassignedUser = !resource;
      const isLoading = !UuidUtils.validate(resource?.id ?? '') && !this.isUnassignedUser;
      this.resource = isLoading || !resource?.id ? undefined : resource;
    }
  }

  public refresh() {
    return true;
  }

  public expand(expand = true) {
    if (!this.node?.group) return;

    this.node?.setExpanded(expand);
  }
  public toggleExpand() {
    this.expand(!this.node?.expanded);
  }
}
